import HelperService from './services/HelperService';
import RequestService from './services/RequestService';
import TypesService from './services/TypesService';
import store from './store';

export function register() {
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', () => {
			navigator.serviceWorker
				.register('/service-worker.js')
				.then(reg => console.log('SW registered:', reg))
				.catch(err => console.error('SW registration failed', err));
		});
	} else {
		console.log("Don't support in this browser");
	}
}

export const pushSubscribe = async () => {
	try {
		if (Notification?.permission !== 'granted') {
			const notificationPermission = await Notification.requestPermission();
			if (notificationPermission !== 'granted') return;
		}

		const registration = await navigator.serviceWorker.ready;

		// let subscription = await registration.pushManager.getSubscription();

		// проверка для избежания повторных подписок.
		// if (!subscription) { // Работает плохо потому что если бэк обновит PubKey, то старые подписка станут неактуальны, а новые не будут созданы
		const { PubKey } = await RequestService.GetPushSubscriptionKey();
		const subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: HelperService.urlBase64ToUint8Array(PubKey),
		});
		// }

		const subscribeData = {
			Endpoint: subscription.endpoint,
			P256dhKey: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))),
			AuthKey: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))),
			BrowserType: store.getState().app.isPWA ? 2 : 1,
		};

		RequestService.PushSubscribe(subscribeData);
	} catch (error) {
		console.log('pushSubscribe Error:', error);
	}
};

window.self.addEventListener('push', event => {
	if (event.data) {
		const data = event.data.json();
		const options = {
			body: data.data,
			vibrate: [100, 50, 100],
		};

		if (data.type === 0) {
			return;
		} else {
			// const intl = createIntl({});
			event.waitUntil(
				window.self.registration.showNotification(TypesService.PustNotifficationTitles[data.type], options)
			);
		}
	}
});
